module.exports = __webpack_public_path__ + "img/QRcode.4c0108d3.svg";